import styled from "styled-components";
import { Flex } from "@chakra-ui/layout";
import { green700 } from "core/resources/theme/colors";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const Wrapper = styled(Flex)`
  z-index: 100;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  padding: 16px;
  padding-left: 0;
  height: 60px;
  .section-edit-profile:hover {
    .text-edit-profile {
      color: ${green700};
    }
    .icon-edit-profile {
      color: ${green700};
    }
  }
`;

export const FlexStyled = styled.div`
  display: flex;
  flex: 1;
  margin-left: 107px;

  @media print {
    margin-left: 5px;
  }
`;